import React, { Fragment } from 'react';
import { connect } from 'react-redux';


// Components

import CommonHeaderContainer from '../../containers/ssap/CommonHeaderContainer';
import SsapNavBarContainer from '../../containers/ssap/SsapNavBarContainer';
import PagesContainer from '../../containers/ssap/PagesContainer';
import AgentPromotion from '../individualPortal/AgentPromotion';


const Ssap = props => {

    const {
        adjustedFlow,
        data: {
            currentPage
        },
        launchData: {
            consumer
        },
        history
    } = props;

    const isCAP = consumer === 'CAP';
    const mainGridClass = 'desktop:grid-col-9';



    return (
        !isCAP
            ? <main className='usa-layout-docs usa-section main-section'>
                <div className="grid-container grid-widescreen gi-grid-container">
                    <div className="grid-row mobile-wrapper--inverse">
                        <SsapNavBarContainer {...props} />
                        <div className={`usa-layout-docs__main ${mainGridClass} usa-prose`} id="main-content">
                            {
                                currentPage !== -1 &&

                                <Fragment>
                                    <CommonHeaderContainer />
                                    <PagesContainer {...{ adjustedFlow, history }} />
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
                <AgentPromotion />
            </main>
            : <div className={`usa-layout-docs__main ${mainGridClass} usa-prose`}>
                {
                    currentPage !== -1 &&
                    <Fragment>
                        <CommonHeaderContainer />
                        <PagesContainer {...{ history }} />
                    </Fragment>
                }
            </div>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    launchData: state.ssap.launchData
});


export default connect(mapStateToProps)(Ssap);
